<template>
    <ai-subtitle value="Свидетельство о регистрации" />
</template>

<script setup>
// import { inject } from 'vue';
import AiSubtitle from '@/components/ai-subtitle.vue';

// const data = inject("data");
</script>
